import React from 'react';
import './Loader.css';

export default function Loader() {
    return (
        <div class="progress-loader">
            <div id="progress"></div>
        </div>
    )
}